import React, {useState, useEffect} from 'react';

import {Column, Row} from '../../../components/layout';
import RegisterHeader from '../../../components/headers/register-header';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {addToWizard, setWizard} from '../../../store/actions';
import {
  AppForm,
  AppFormCheckboxField,
  AppFormSubmitButton,
} from '../../../components/forms';
import * as Yup from 'yup';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import Header2 from '../../../components/headers/header2';
import Header1 from '../../../components/headers/header1';
import * as fonts from '../../../util/fonts';
import './styles.scss';
import colors from '../../../util/colors';
import {get} from '../../../api/api';
import {
  uriGetUserByTaxNumber,
  uriGetUserByTaxNumberCMD,
  uriPostConsentReceipts,
} from '../../../api/endpoints';
import {
  ApiResponse,
  createGUID,
  getDateInServerFormat,
} from '../../../util/utility';
import {Link, useHistory} from 'react-router-dom';
import {post} from '../../../api/api';
import MyProfilePopup from './myProfile-popup/MyProfilePopup';
import {ITenant} from '../../../App';

export interface CommunicationsProps {
  wizard: any;
  addToWizard(value: any): void;
  labels: typeof strings.pt.register;
  oneTrust: typeof strings.pt.oneTrust;
  globalStyles: any;
  busFuncMapDefault: any;
  tenant: ITenant;
}

const validationSchema = Yup.object().shape({
  marketingCommunication: Yup.boolean().required(),
  healthAdvices: Yup.boolean().required(),
});

function Communications(props: CommunicationsProps) {
  const {addToWizard, wizard, oneTrust} = props;
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();

  const [showMyProfile, setShowMyProfile] = useState(false);

  const nif = wizard?.insuranceValidation?.nif;
  const token = oneTrust?.tokenMyAdv;
  const acceptedTermsAndConditions =
    props.wizard.insuranceValidation?.acceptedTermsAndConditions;
  const acceptedDataTreatment =
    props.wizard.insuranceValidation?.acceptedDataTreatment;
  let purposes: any = [];

  const generateBody = (communicationsConsents: any) => {
    if (acceptedTermsAndConditions) {
      purposes.push({Id: oneTrust?.purposeTermsAndConditions});
    }
    if (acceptedDataTreatment) {
      purposes.push({Id: oneTrust?.purposePolicyDataTreatment});
    }
    if (communicationsConsents.marketingCommunication) {
      purposes.push({Id: oneTrust?.purposeMarketingComunications});
    }
    if (communicationsConsents.healthAdvices) {
      purposes.push({Id: oneTrust?.purposeHealthPrevention});
    }
    return JSON.stringify({
      identifier: nif,
      test: true,
      requestInformation: token,
      purposes: purposes,
    });
  };

  const retrieveUserContacts = async (
    dateOfBirth: any,
    communications: any
  ) => {
    await get(uriGetUserByTaxNumber(nif, getDateInServerFormat(dateOfBirth)))
      .then((res: any) => {
        if (res.status === 500) {
          throw new Error(res.detail);
        }
        const dataValidation = {currentUser: {...res?.data}};
        addToWizard({dataValidation});
      })
      .catch((e: any) => {
        console.log('e', e);
      })
      .finally(() => {
        addToWizard({communications});
        const body = generateBody(communications);

        const oneTrustIsVisible =
          props.busFuncMapDefault &&
          props.busFuncMapDefault[functionalitiesAliasMap.oneTrust];

        oneTrustIsVisible &&
          post(uriPostConsentReceipts(), body).catch((e: any) => {});
        setSubmitting(false);
      });
  };

  const onSubmit = async (values: any) => {
    setSubmitting(true);
    const communications = {
      marketingCommunication: values.marketingCommunication,
      healthAdvices: values.healthAdvices,
    };

    const {nif, dateOfBirth} = props.wizard.insuranceValidation;

    // check if user is registered already
    await get(uriGetUserByTaxNumberCMD(nif))
      .then(async (response: ApiResponse | unknown) => {
        console.log('res', response);
        const res = response as ApiResponse;
        if (res?.data?.isRegisteredInWSO2) {
          history.push('/utilizador-existente');
        } else {
          retrieveUserContacts(dateOfBirth, communications);
        }
      })
      .catch((e: any) => {
        console.log('e', e);
        retrieveUserContacts(dateOfBirth, communications);
      });
  };

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Row className="register-container app-center">
        <Column className="communications-container-column">
          <AppForm
            className="communications-form-container"
            initialValues={{
              marketingCommunication: false,
              healthAdvices: false,
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => onSubmit(values)}>
            <Row className="communications-header">
              <Header1
                style={{...fonts.XL, ...fonts.Bold, color: colors.black}}
                className="header-communications">
                {props.labels?.register_beforeContinueTitle}
              </Header1>
              <Header1
                style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
                className="header-communications-responsive">
                {props.labels?.register_beforeContinueTitle}
              </Header1>
            </Row>
            <Row className="center">
              <Column>
                <Row>
                  <p
                    style={{...fonts.ML}}
                    className="register-before-continue-subtitle1">
                    {props.labels?.register_beforeContinueSubtitle1}
                  </p>
                </Row>
                <Row className="communications-checkbox-row">
                  <AppFormCheckboxField
                    purposeId={oneTrust?.purposeMarketingComunications}
                    name="marketingCommunication"
                    className="communications-checkbox"
                    label={
                      <label
                        style={{
                          ...fonts.SM,
                          ...fonts.Medium,
                        }}
                        className="align-left-label">
                        {props.labels?.register_beforeContinueCheckbox1Text}{' '}
                        <Link
                          className="communications-anchor"
                          style={{
                            color: props.globalStyles?.primaryColor,
                          }}
                          to="#"
                          onClick={() => setShowMyProfile(true)}>
                          {props.labels?.register_beforeContinueCheckbox1Link}
                        </Link>
                      </label>
                    }
                  />
                </Row>
                <div>
                  <MyProfilePopup
                    show={showMyProfile}
                    setShowModal={setShowMyProfile}
                  />
                </div>
                <Row>
                  <p
                    style={{...fonts.ML}}
                    className="register-before-continue-subtitle2">
                    {props.labels?.register_beforeContinueSubtitle2}
                  </p>
                </Row>
                <Row className="communications-checkbox-row">
                  <AppFormCheckboxField
                    purposeId={oneTrust?.purposeHealthPrevention}
                    name="healthAdvices"
                    className="communications-checkbox"
                    label={
                      <label
                        style={{...fonts.SM, ...fonts.Medium}}
                        className="align-left-label">
                        {props.labels?.register_beforeContinueCheckbox2Text1}
                        <Link
                          className="communications-anchor"
                          style={{
                            color: props.globalStyles?.primaryColor,
                          }}
                          to="#"
                          onClick={() => setShowMyProfile(true)}>
                          {props.labels?.register_beforeContinueCheckbox2Link}
                        </Link>
                        {props.labels?.register_beforeContinueCheckbox2Text2}
                      </label>
                    }
                  />
                </Row>
                <Row className="app-center">
                  <AppFormSubmitButton
                    disabled={submitting}
                    className="communications-button"
                    title={props.labels?.register_confirmButton}
                  />
                </Row>
              </Column>
            </Row>
          </AppForm>
        </Column>
      </Row>
    </Column>
  );
}

const mapStateToProps = ({
  wizard,
  strings,
  stringsDefault,
  globalStyles,
  busFuncMapDefault,
  tenant,
}: any) => ({
  wizard: wizard.value,
  labels: strings.value.pt.register,
  oneTrust: stringsDefault.value.pt.oneTrust,
  globalStyles: globalStyles.value,
  busFuncMapDefault: busFuncMapDefault.value,
  tenant: tenant.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(Communications)
);
